module.exports = __webpack_public_path__ + "img/eligibility-chech-mail.6c456e3b.png";